import { useState, useMemo } from 'react';
import { Modal, Button, Space, Input } from 'antd';
import useStaff from "@/hooks/useStaff";
import { Staff } from '@/models/user';

const Index: React.FC<{ handleSetEditor: (staff: Staff | undefined) => Promise<boolean>; }> = ({ handleSetEditor }) => {
  const [visible, setVisible] = useState<boolean>(false);
  const { data: staffList } = useStaff();
  const [userKeyword, setUserKeyword] = useState<string>('');
  const [selectedUser, setSelectedUser] = useState<string[]>([]);

  const currentStaff = useMemo(() => {
    if (!userKeyword) return staffList;
    return staffList.filter((item: { name: string; userid: string }) => item.name.includes(userKeyword));
  }, [userKeyword, staffList])

  const clear = () => {
    setVisible(false);
    setSelectedUser([]);
  }

  return <>
    <Button type="primary" onClick={() => setVisible(true)}>设置协作者</Button>
    <Modal
      visible={visible}
      onCancel={clear}
      width={'80vw'}
      onOk={async () => {
        if (selectedUser.length === 0) return;
        if (await handleSetEditor(staffList.find(s => s.userid === selectedUser[0]))) {
          clear();
        }
      }}
    >
      <Space direction="vertical">
        <Input placeholder="输入关键字" onChange={e => setUserKeyword(e.target.value)} />
        <div style={{ width: '100%' }}>
          {
            currentStaff.map((s: { name: string; userid: string }) => <Button style={{ marginBottom: 10, marginRight: 10 }} key={s.userid} type={selectedUser.includes(s.userid) ? 'primary' : 'default'} onClick={() => {
              if (!selectedUser.includes(s.userid)) {
                setSelectedUser([s.userid])
              }
            }}>
              {s.name}-{s.userid}
            </Button>)
          }
        </div>
      </Space>
    </Modal>
  </>
}

export default Index;